<template>
  <a-card :bordered="false">
    <div>
      <a-button type="primary" @click="openModel">绑定商品</a-button>
    </div>
    <custom-page-table
      style="margin-top: 16px;"
      ref="table"
      :columns="columns"
      :requestPromise="loadPromise"
    >
      <span slot="action" slot-scope="rowItem">
        <a @click="unbind(rowItem.record)">删除绑定</a>
      </span>
    </custom-page-table>
    <a-modal title="商品绑定" :width="666" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="所属供应商" prop="channelId">
          <a-select v-model="ruleForm.channelId" @select="selectChannel" placeholder="请选择供应商">
            <a-select-option v-for="item in providerList" :key="item.accountId" :value="item.accountId">
              {{ item.accountName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="关联商品" prop="proId">
          <a-button type="primary" @click="toSelectedProductEvent">选择商品</a-button>
          <span style="margin-left: 10px;">*仅能关联门票类型且未上架的自有商品</span>
        </a-form-model-item>
        <a-form-model-item v-if="selectedProduct.proName" label="商品名称">
          <span style="margin-left: 10px;">{{ selectedProduct.proName }}</span>
        </a-form-model-item>
        <a-form-model-item label="选择票型" prop="optionId">
          <a-select v-model="ruleForm.optionId" placeholder="请选择票型">
            <a-select-option v-for="item in optionList" :key="item.optionId" :value="item.optionId">
              {{ item.optionName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="供应商票型ID(商品编号)" prop="supplyOptionId">
          <a-input v-model="ruleForm.supplyOptionId" placeholder="请输入供应商票型ID(商品编号)"></a-input>
        </a-form-model-item>
        <div style="text-align: center;">
          <a-button type="primary" @click="updateBindingProduct()">保存设置</a-button>
        </div>
      </a-form-model>
    </a-modal>
    <a-modal title="商品选择" :width="900" :footer="null" :visible="productVisible" @cancel="productCancel">
      <a-form layout="inline">
        <a-form-item label="商品ID">
          <a-input v-model="queryParams.proId" placeholder="请输入商品ID"></a-input>
        </a-form-item>
        <a-form-item label="商品名称">
          <a-input v-model="queryParams.proName" placeholder="请输入商品名称"></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="$refs.productList.refresh(true)">
            查询
          </a-button>
        </a-form-item>
      </a-form>
      <custom-page-table
        :queryParams="queryParams"
        style="margin-top: 16px;"
        ref="productList"
        :columns="columnsProduct"
        base-key="proUrl"
        params-path="wisdom/query/pro/list"
      >
        <span slot="index" slot-scope="rowItem">{{ rowItem.index + 1 }}</span>
        <span slot="action" slot-scope="rowItem">
          <a @click="onSourceItemClick(rowItem.record)">选择</a>
        </span>
      </custom-page-table>
    </a-modal>
  </a-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'zhiyoubaoConnection',
  data() {
    return {
      loadPromise: params => this.getDataList(params),
      labelCol: { span: 7 },
      wrapperCol: { span: 14 },
      queryParams: {},
      columns: [
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '票型',
          dataIndex: 'optionName'
        },
        {
          title: '类型',
          dataIndex: 'proType'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime'
        },
        {
          title: '供应商名称',
          dataIndex: 'channelName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      columnsProduct: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      rules: {
        channelId: [
          { required: true, message: '请选择供应商', trigger: 'change' }
        ],
        proId: [
          { required: true, message: '请选择商品', trigger: 'change' }
        ],
        optionId: [
          { required: true, message: '请选择票型', trigger: 'change' }
        ],
        supplyOptionId: [
          { required: true, message: '请输入供应商票型ID(商品编号)', trigger: 'change' }
        ]
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      selectedType: 0,
      visible: false,
      productVisible: false,
      ruleForm: {
        channelId: undefined, //: 关联账号Id(供应商Id)
        supplyOptionId: '', //供应商票型Id ,
        optionId: undefined, //票型Id ,
        proId: '',//商品ID ,
        channelName: ''
      },
      providerList: [],
      selectedProduct: {},
      optionList: []
    }
  },
  computed: {
    ...mapState({
      vesion: state => state.config.serverDataInfo.vesion
    })
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'CitGroupConnection', title: '商品绑定' },
      { name: 'CitGroupOrderConnection', title: '订单直连' },
      { name: 'CitGroupAddAccount', title: '关联账号' }
    ])
    this.getProviderList()

  },
  methods: {
    selectChannel(value) {
      this.ruleForm.channelName = this.providerList.find(item => item.accountId == value).accountName
    },
    getDataList(params) {
      return this.getHttpServices().getProService().post('zzTour/getZZTourBindProductPage', params)
    },
    //选择商品
    toSelectedProductEvent() {
      this.productVisible = true
    },
    //商品数据点击
    onSourceItemClick(item) {
      this.selectedProduct = item
      this.getOptionList(item.proId)
      this.ruleForm.optionId = undefined
      this.ruleForm.proId = item.proId
      this.productVisible = false
    },
    //保存（更新绑定商品）
    updateBindingProduct() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let params = {
            ...this.ruleForm
          }
          this.getHttpServices()
            .getProService()
            .post('/zzTour/bindZZTourBindProduct', params)
            .then(res => {
              this.$message.success('绑定成功')
              this.visible = false
              this.$refs.table.refresh(true)
            })
            .catch(err => {
              this.$message.error('绑定失败')
            })

        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    //解除绑定
    unbind(record) {
      let params = {
        optionId: record.optionId,
        proId: record.proId
      }
      this.getHttpServices().getProService().post('zzTour/removeZZTourBindProduct', params)
        .then(res => {
          this.$message.success('解除成功')
          this.$refs.table.refresh(true)
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    getOptionList(proId) {
      this.getHttpServices()
        .getProService()
        .post('product/option/getOptionListByProId/1/100/' + proId)
        .then(res => {
          this.optionList = res.data
        })
        .catch(err => {
          this.getLogUtils().logWithTag('err', err)
        })
    },
    //获取供应商列表
    getProviderList() {
      this.getHttpServices().getServerApiService().post('zzTour/account/list', {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      })
        .then(res => {
          this.providerList = res
        })
        .catch(err => {
          this.getLogUtils().logWithTag('err', err)
        })
    },
    productCancel() {
      this.productVisible = false
    },
    //关联账号
    addAccount() {
      this.$router.push({
        name: 'AddAccount',
        query: {
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    openModel() {
      this.visible = true
      this.ruleForm = {
        channelId: undefined, //: 关联账号Id(供应商Id)
        channelName: '',
        supplyOptionId: '', //供应商票型Id ,
        optionId: undefined, //票型Id ,
        proId: '' //商品ID ,
      }
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
<style scoped></style>
